// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".totais {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 12px 0;\n}\n.totais span {\n  font-size: 20px;\n  color: #008e9e;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
